module.exports = __webpack_public_path__ + "media/src/images/feature-bg-02-7411b66ff73541c07f24ee2df6091279.png";